

/** 短信code场景值 */
export enum ECodeScene {
  /** 注册 */
  REG = 'REG',
  /** 忘记密码 */
  FORGOT = 'FORGOT'
}